import React from "react";
import { Sparkles, ShieldCheck, Lock, Truck } from "lucide-react";

/**
 * Slim, single-line credibility strip displayed directly under the hero.
 * Complements (does not duplicate) the larger guarantee TrustBar — this
 * version is about facts & positioning, not promises.
 *
 * - Dark band so it visually divides the hero from the catalogue.
 * - 4 items on desktop, 2x2 grid on mobile.
 * - Compact: 1 icon + 1 line each, no descriptions.
 */
const ITEMS = [
  { icon: Sparkles, label: "30+ designer houses", mobile: "30+ designers", testid: "credibility-designers" },
  { icon: ShieldCheck, label: "Hand-authenticated", mobile: "Authenticated", testid: "credibility-authenticated" },
  { icon: Lock, label: "Stripe Secure checkout", mobile: "Stripe Secure", testid: "credibility-stripe" },
  { icon: Truck, label: "Free US shipping over $200", mobile: "Free shipping", testid: "credibility-shipping" },
];

export default function CredibilityStrip() {
  return (
    <section
      className="bg-[var(--mn-ink)] text-[var(--mn-bg)]"
      data-testid="credibility-strip"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-12 py-5 md:py-6 grid grid-cols-2 md:grid-cols-4 gap-y-4 md:gap-y-0 md:divide-x md:divide-white/15">
        {ITEMS.map(({ icon: Icon, label, mobile, testid }, i) => (
          <div
            key={label}
            className={`flex items-center gap-2.5 md:gap-3 justify-center md:px-6 ${i < 2 ? "border-b md:border-b-0 border-white/15 pb-4 md:pb-0" : ""}`}
            data-testid={testid}
          >
            <Icon size={16} strokeWidth={1.4} className="shrink-0 text-[var(--mn-bg)]/70" />
            <span className="text-[10px] md:text-xs uppercase tracking-[0.18em] md:tracking-[0.22em] font-medium leading-tight">
              <span className="md:hidden">{mobile}</span>
              <span className="hidden md:inline whitespace-nowrap">{label}</span>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
